// src/store/slices/toastsSlice.js
import { createSlice } from '@reduxjs/toolkit';

const toastsSlice = createSlice({
  name: 'toasts',
  initialState: [],
  reducers: {
    addToast(state, action) {
      state.push(action.payload);
    },
    removeToast(state, action) {
      return state.filter((t) => t.id !== action.payload);
    },
  },
});

export const { addToast, removeToast } = toastsSlice.actions;
export default toastsSlice.reducer;

/**
 * Thunk: dispatch a self-dismissing toast notification.
 * @param {string} message
 * @param {'default'|'success'|'error'} type
 * @param {number} duration  ms before auto-dismiss (default 3000)
 */
export function showToast(message, type = 'default', duration = 3000) {
  return (dispatch) => {
    const id = Math.random().toString(36).slice(2, 9);
    dispatch(addToast({ id, message, type }));
    setTimeout(() => dispatch(removeToast(id)), duration);
  };
}
